import { createContext } from 'react';

type ModalDialogContext = {
  isDismissable: boolean;
};

/**
 * Context responsible for passing `isDismissable` to `ModalDialog` children components.
 */
export const ModalDialogContext = createContext<ModalDialogContext | undefined>(
  undefined
);
